import * as React from 'react';
import { createViewConfig } from '@sail/engine';
import { Input } from './Input';
import { useFormFieldProps, FormField } from './FormField';
import { css } from '../css';
export const NativeTextFieldConfig = createViewConfig({
    props: {},
    name: 'NativeTextField',
    flattens: true,
    defaults: {
        size: 'medium',
        type: 'text'
    }
});
export const NativeTextField = NativeTextFieldConfig.createView((props)=>/*#__PURE__*/ React.createElement(Input, props), {
    css: {
        // Shadows get clipped on ios safari without appearance: none
        appearance: 'none',
        backgroundColor: 'form',
        border: 'none',
        borderRadius: 'form',
        keyline: 'form',
        textColor: 'form',
        font: 'label.medium',
        stack: 'x',
        transition: 'box-shadow 240ms',
        width: 'fill',
        boxSizing: 'border-box',
        '::placeholder': {
            color: 'form.placeholder'
        },
        ':disabled': {
            backgroundColor: 'form.disabled',
            color: 'form.disabled'
        },
        ':focus': {
            focusRing: 'focus',
            keyline: 'form.focused'
        },
        '[aria-invalid="true"]': {
            keyline: 'form.error'
        }
    },
    forward: {
        type: true
    },
    variants: {
        type: {
            number: [
                css({
                    '::-webkit-outer-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 'space.0'
                    },
                    '::-webkit-inner-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 'space.0'
                    },
                    '-moz-appearance': 'textfield'
                })
            ]
        },
        size: {
            small: css({
                paddingX: 'small',
                paddingY: 'xsmall',
                font: 'label.small'
            }),
            medium: css({
                paddingX: 'small',
                paddingY: 'xsmall'
            }),
            large: css({
                paddingX: 'space.150',
                paddingY: 'small',
                font: 'label.large'
            })
        }
    }
});
export const TextFieldConfig = createViewConfig({
    props: {},
    name: 'TextField',
    flattens: true
});
/**
 * @external
 * @param autoComplete
 * @param autoFocus
 * @param defaultValue
 * @param disabled
 * @param form
 * @param maxLength
 * @param minLength
 * @param name
 * @param onChange
 * @param onKeyPress
 * @param onKeyDown
 * @param onKeyUp
 * @param placeholder
 * @param readOnly
 * @param required
 * @param spellCheck
 * @param tabIndex
 * @param type
 */ export const TextField = TextFieldConfig.createView((props)=>{
    const [fieldProps, controlProps] = useFormFieldProps(props);
    return /*#__PURE__*/ React.createElement(FormField, fieldProps, /*#__PURE__*/ React.createElement(NativeTextField, {
        ...controlProps,
        inherits: props.subviews.input
    }));
});

//# sourceMappingURL=TextField.js.map